// extracted by mini-css-extract-plugin
module.exports = {"price":"PriceItem_price__uS196","originalPrice":"PriceItem_originalPrice__30sdg"};